import React, { useRef } from 'react';
import { createStyles, useTheme } from '@/contexts/theme-context';
import { Pressable, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useHover } from 'react-native-web-hooks';

export interface TimeslotOptionItemProps {
  displayText: string;
  isDisabled?: boolean;
  onPress?: () => void;
}

export const TimeslotOptionItem: React.FC<TimeslotOptionItemProps> = ({
  displayText,
  isDisabled = false,
  onPress,
}) => {
  const theme = useTheme();
  const [styles] = useStyles();
  const pressableRef = useRef<React.ComponentRef<typeof Pressable>>(null);
  const isHovered = useHover(pressableRef);

  if (isDisabled) {
    return (
      <View style={styles.timeslotOption}>
        <Typography color={theme.sk.color.text.disabled} variant="paragraph-md">
          {displayText}
        </Typography>
      </View>
    );
  }

  return (
    <Pressable
      onPress={onPress}
      ref={pressableRef}
      style={[styles.timeslotOption, isHovered && styles.timeslotOptionHovered]}
    >
      <Typography color={theme.sk.color.text.primary} variant="paragraph-md">
        {displayText}
      </Typography>
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  timeslotOption: {
    borderRadius: theme.sk.radii.radiusSmall,
    paddingHorizontal: theme.sk.spacing.spaceXsmall,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  timeslotOptionHovered: {
    backgroundColor: theme.sk.color.bg.primary.hover,
  },
}));
